module.exports = __webpack_public_path__ + "static/3-mission1-Text-56ad9576244a52fe51dc311babb02124.png";